import { ContentDetector, languages } from "@codeshare/languages";

// One detector (and one model worker) for the app; the worker starts on first use.
let detector: ContentDetector | undefined;

export function detectContent(content: string) {
  detector ??= new ContentDetector(languages);
  return detector.detect(content);
}
